import Vue from 'vue';
import store from 'store';
import debounce from 'lodash.debounce';
import { Scrollbar, A11y, Keyboard, Navigation } from "swiper/modules";
import { trackExclusiveServicesClick } from 'lib/tracking';

export default (el) =>
  new Vue({
    el,
    store,
    components: {
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue')
    },
    data() {
      return {
        swiper: null,
        swiperOptions: {
          modules: [Scrollbar, A11y, Keyboard, Navigation],
          slidesPerView: 1.4,
          loop: false,
          spaceBetween: 10,
          navigation: {
            nextEl: `#${el.id} .slider-next`,
            prevEl: `#${el.id} .slider-prev`
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true
          },
          breakpoints: {
            769: {
              slidesPerView: 3.4,
              spaceBetween: 20
            }
          },
          a11y: {
            enabled: true,
            slideLabelMessage: null
          },
          keyboard: true
        }
      }
    },
    mounted() {
      if (this.swiperOptions) {
        this.swiperOptions.on = {
          init: (swiper) => {
            this.swiper = swiper;
            this.updateSlideAccessibility(swiper);
          },
          slideChange: (swiper) => {
            this.updateSlideAccessibility(swiper);
          },
          resize: (swiper) => {
            const heights = swiper.slides.map((slide) => slide.offsetHeight);
            const maxHeight = Math.max(...heights);
            swiper.slides.forEach((slide) => {
              slide.style.height = `${maxHeight}px`;
            });
          }
        };
      }
    },
    methods: {
      updateSlideAccessibility(swiper) {
        if (!swiper) return;
        swiper.slides.forEach((slide, index) => {
          if (index === swiper.activeIndex) {
            slide.setAttribute('aria-hidden', 'false');
            slide.removeAttribute('tabindex');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('tabindex', '-1');
          }
        });
      },
      trackClick(url, title, section, is_anchor) {
        if (is_anchor == 'true') {
          const callback = () => {
            const headerHeight =
              document.querySelector('.header-wrapper')?.offsetHeight || 100;
            const target = document.querySelector(url);
            if (target) {
              window.scrollTo({
                top: target.offsetTop - headerHeight,
                behavior: 'smooth',
              });
            }
          };
          trackExclusiveServicesClick(url, title, section, callback);
        } else {
          trackExclusiveServicesClick(url, title, section);
        }
      }
    }
  });
